module.exports = __webpack_public_path__ + "img/site_type_img_06.eac2c82a.png";